<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  sending: {
    type: Boolean,
    default: false,
  },
  clearSignal: {
    type: Number,
    default: 0,
  },
  placeholder: {
    type: String,
    default: '请输入问题',
  },
  manualMode: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['submit'])

const inputValue = ref('')
const helperText = computed(() => props.manualMode
  ? '当前会话已进入人工处理，回车发送，Shift + 回车换行'
  : '回车发送，Shift + 回车换行')

function handleSubmit() {
  const content = inputValue.value.trim()
  if (!content || props.sending) {
    return
  }

  emit('submit', content)
}

function handleKeydown(event) {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault()
    handleSubmit()
  }
}

watch(
  () => props.clearSignal,
  () => {
    inputValue.value = ''
  }
)
</script>

<template>
  <div class="customer-service-input">
    <el-input
      v-model="inputValue"
      type="textarea"
      resize="none"
      :rows="3"
      :disabled="props.sending"
      :placeholder="props.placeholder"
      @keydown="handleKeydown"
    />
    <div class="customer-service-input__actions">
      <span>{{ helperText }}</span>
      <el-button type="primary" :loading="props.sending" @click="handleSubmit">
        发送
      </el-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.customer-service-input {
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid #e4ebfb;
  padding: 14px 16px 16px;
  background: linear-gradient(180deg, rgba(245, 248, 255, 0.96) 0%, #ffffff 100%);
  backdrop-filter: blur(10px);
}

.customer-service-input__actions {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #7484a5;
  font-size: 12px;
}
</style>
